// src/utils/whatsapp.js
// ============================================================
// NUMEROS WHATSAPP — normalisation avant construction du lien
// ------------------------------------------------------------
// Pourquoi ce fichier : le bouton WhatsApp "ne marchait pas sur iPhone".
// La cause n'est pas iOS mais le FORMAT du numero. Les composants se
// contentaient de `String(num).replace(/\D/g,'')`, ce qui laisse passer
// deux formats invalides pour wa.me :
//
//   00212663033383  -> wa.me n'accepte pas le prefixe international 00
//   0663033383      -> numero local, sans indicatif pays
//
// Android intercepte souvent le lien avec l'application WhatsApp et
// rattrape l'erreur ; Safari sur iOS suit reellement l'URL et tombe sur
// la page "Numero de telephone invalide". D'ou le symptome : ca marche
// sur Android, pas sur iPhone.
//
// wa.me exige le numero au format international SANS +, sans 00 et sans
// espaces : 212663033383.
// ============================================================

// Indicatif pays par defaut pour les numeros saisis au format local (0X...).
const DEFAULT_COUNTRY_CODE = '212'; // Maroc

/**
 * Normalise un numero pour wa.me.
 * Accepte : "+212 663 03 33 83", "00212663033383", "0663033383", "212663033383".
 * Retourne : "212663033383", ou '' si le numero est inexploitable.
 */
export const waNumber = (input, countryCode = DEFAULT_COUNTRY_CODE) => {
  let digits = String(input || '').replace(/\D/g, '');
  if (!digits) return '';

  // Prefixe international "00" -> a retirer (wa.me ne l'accepte pas)
  if (digits.startsWith('00')) digits = digits.slice(2);

  // Numero local marocain (0612345678) -> 212612345678
  if (digits.startsWith('0')) digits = countryCode + digits.slice(1);

  // Indicatif COLLE au numero local, sans retirer le 0 : 212 + 0612345678.
  // C'est l'erreur de saisie la plus frequente (on prefixe l'indicatif devant le
  // numero tel qu'on l'ecrit au Maroc, en gardant le 0). Le resultat fait 13
  // chiffres au lieu de 12 et wa.me le refuse. Le format valide n'a PAS de 0
  // apres l'indicatif : 212612345678, jamais 2120612345678.
  if (digits.startsWith(countryCode + '0') && digits.length === countryCode.length + 10) {
    digits = countryCode + digits.slice(countryCode.length + 1);
  }

  // Numero national sans le 0 (612345678, 9 chiffres) -> ajouter l'indicatif
  if (digits.length === 9 && !digits.startsWith(countryCode)) {
    digits = countryCode + digits;
  }

  // Trop court pour etre un numero international valide
  if (digits.length < 10) return '';

  return digits;
};

/**
 * Construit un lien wa.me complet.
 * Sans numero exploitable, retourne un lien de partage generique
 * (WhatsApp demande alors le destinataire) plutot qu'une URL cassee.
 */
export const waLink = (input, text = '') => {
  const num = waNumber(input);
  const query = text ? `?text=${encodeURIComponent(text)}` : '';
  return num ? `https://wa.me/${num}${query}` : `https://wa.me/${query}`;
};

export default { waNumber, waLink };
